import { render, staticRenderFns } from "./supplierTrain.vue?vue&type=template&id=0e2d1488&scoped=true&"
import script from "./supplierTrain.vue?vue&type=script&lang=js&"
export * from "./supplierTrain.vue?vue&type=script&lang=js&"
import style0 from "./supplierTrain.vue?vue&type=style&index=0&id=0e2d1488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d1488",
  null
  
)

export default component.exports